<div class="_client-origins-desktop-component">

    <table-desktop-component 
        [headers]="tableHeaders"
        [dataRequest]="controller.dataRequest" 
        (dataChanged)="controller.dataChanged($event)" 
        stateKey="client-origins"
    >

		<button type="button" button class="_button _add-button" (click)="controller.openClientOrigin()" *ifUserHasPermissions="[UserPermissions.WriteConfigurations]">
			<ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
			<span >{{ 'CLIENT_ORIGIN.CREATE' | translate}}</span>
		</button>  

        <ion-row data class="_row _data ion-align-items-center" *ngFor="let clientOrigin of controller.clientOrigins">
			<table-col [size]="4">{{clientOrigin.name}}</table-col>
			<table-col [size]="10">{{clientOrigin.description}}</table-col>
			<table-col>
                <button *ifUserHasPermissions="[UserPermissions.ReadConfigurations]" type="button" class="_button _info-button" (click)="controller.openClientOrigin(clientOrigin)"  title="{{ 'CLIENT_ORIGIN.EDIT' | translate}}">
                    <ion-icon *ifUserHasPermissions="[UserPermissions.WriteConfigurations]" src="./assets/icons/edit-outline-simple.svg"></ion-icon>
                    <ion-icon *ifUserHasNotPermissions="[UserPermissions.WriteConfigurations]" src="./assets/icons/info-outline.svg"></ion-icon>
                </button>
            </table-col>
        </ion-row>
    </table-desktop-component>

</div>